import {
  format,
  subDays,
  subMonths,
  startOfMonth,
  endOfMonth,
  startOfYear,
  startOfDay,
  endOfDay,
  isValid
} from 'date-fns';
import { es } from 'date-fns/locale';

export const formatDate = (date, granularity = 'daily') => {
  // Validar que la fecha sea válida antes de formatear
  if (!date || !isValid(date)) {
    console.warn('Fecha inválida en formatDate:', date);
    return 'N/A';
  }
  const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  if (granularity === 'weekly') {
    return format(utcDate, 'dd/MM', { locale: es });
  } else if (granularity === 'monthly') {
    return format(utcDate, 'MMMM', { locale: es });
  } else if (granularity === 'full-year-day') {
    return format(utcDate, 'yyyy-MM-dd', { locale: es });
  } else if (granularity === 'full-year-short') {
    return format(utcDate, 'dd/MM/yy', { locale: es });
  }
  return format(utcDate, 'dd/MM', { locale: es });
};

// Función para calcular fechas según el tipo de período
export const calculateDateRange = (periodKey, days, customStartDate = '', customEndDate = '') => {
  const today = new Date();
  today.setHours(12, 0, 0, 0); // set to local midday
  
  switch (periodKey) {
    case 'TODAY': {
      const dayStart = startOfDay(today);
      // Usar la misma fecha para start y end (un solo día); formatDate(endOfDay()) puede cruzar a medianoche UTC
      const dateStr = formatDate(dayStart, 'full-year-day');
      return {
        startDate: dayStart,
        endDate: endOfDay(today),
        startDateStr: dateStr,
        endDateStr: dateStr
      };
    }
      
    case 'YESTERDAY': {
      const yesterday = subDays(today, 1);
      const dayStart = startOfDay(yesterday);
      // Usar la misma fecha para start y end (un solo día); formatDate(endOfDay()) puede cruzar a medianoche UTC
      const dateStr = formatDate(dayStart, 'full-year-day');
      return {
        startDate: dayStart,
        endDate: endOfDay(yesterday),
        startDateStr: dateStr,
        endDateStr: dateStr
      };
    }
      
    case 'ESTE_MES':
      const startOfCurrentMonth = startOfMonth(today);
      const endOfCurrentMonth = today;
      return {
        startDate: startOfCurrentMonth,
        endDate: endOfCurrentMonth,
        startDateStr: formatDate(startOfCurrentMonth, 'full-year-day'),
        endDateStr: formatDate(endOfCurrentMonth, 'full-year-day')
      };
      
    case 'MES_PASADO':
      const lastMonth = subMonths(today, 1);
      const startOfLastMonth = startOfMonth(lastMonth);
      const endOfLastMonth = endOfMonth(lastMonth);
      return {
        startDate: startOfLastMonth,
        endDate: endOfLastMonth,
        startDateStr: formatDate(startOfLastMonth, 'full-year-day'),
        endDateStr: formatDate(endOfLastMonth, 'full-year-day')
      };
      
    case 'ESTE_AÑO':
      const startOfCurrentYear = startOfYear(today);
      const endOfCurrentYear = today;
      return {
        startDate: startOfCurrentYear,
        endDate: endOfCurrentYear,
        startDateStr: formatDate(startOfCurrentYear, 'full-year-day'),
        endDateStr: formatDate(endOfCurrentYear, 'full-year-day')
      };
      
    case 'CUSTOM':
      // Período personalizado usando las fechas guardadas
      // Validar que las fechas existan y sean válidas
      if (!customStartDate || !customEndDate) {
        console.warn('Fechas personalizadas inválidas, usando período por defecto');
        const endDate = subDays(today, 1);
        const startDate = subDays(today, 7);
        return {
          startDate,
          endDate,
          startDateStr: formatDate(startDate, 'full-year-day'),
          endDateStr: formatDate(endDate, 'full-year-day')
        };
      }
      
      const customStart = new Date(customStartDate);
      const customEnd = new Date(customEndDate);
      
      // Validar que las fechas sean válidas
      if (!isValid(customStart) || !isValid(customEnd)) {
        console.warn('Fechas personalizadas inválidas, usando período por defecto', { customStartDate, customEndDate });
        const endDate = subDays(today, 1);
        const startDate = subDays(today, 7);
        return {
          startDate,
          endDate,
          startDateStr: formatDate(startDate, 'full-year-day'),
          endDateStr: formatDate(endDate, 'full-year-day')
        };
      }
      
      return {
        startDate: customStart,
        endDate: customEnd,
        startDateStr: formatDate(customStart, 'full-year-day'),
        endDateStr: formatDate(customEnd, 'full-year-day')
      };
      
    default:
      // Períodos numéricos (7D, 14D, 30D, 90D)
      const endDate = subDays(today, 1);
      const startDate = subDays(today, days);
      
      // Validar que las fechas sean válidas
      if (!isValid(startDate) || !isValid(endDate)) {
        console.warn('Fechas calculadas inválidas, usando período por defecto', { days });
        const safeEndDate = subDays(today, 1);
        const safeStartDate = subDays(today, 7);
        return {
          startDate: safeStartDate,
          endDate: safeEndDate,
          startDateStr: formatDate(safeStartDate, 'full-year-day'),
          endDateStr: formatDate(safeEndDate, 'full-year-day')
        };
      }
      
      return {
        startDate,
        endDate,
        startDateStr: formatDate(startDate, 'full-year-day'),
        endDateStr: formatDate(endDate, 'full-year-day')
      };
  }
};

